import React, { useState } from 'react';
import Direction from './Direction';
import callBackend from '../../utils/callBackend';

import Ok from './Ok';
import './TournamentMgmt.css';
import '../../styles/colors.css';

const TournamentMgmt = props => {
    const submitHandler = props.submitHandler;
    const updateTourneamentHandler = props.updateTourneamentHandler;
    const tournamentCreated = props.tournamentCreated;

    const [rainbowValue, setRainbowValue] = useState('');
    const [urlSnippetValue, setUrlSnippetValue] = useState('');
    const [dataSource, setDataSource] = useState('');
    const [tournamentName, setTournamentName] = useState('');
    const [eventName, setEventName] = useState('');
    const [sessionID, setSessionID] = useState('');

    const clickHandler = () => {
        const base = { rainbow: rainbowValue, urlSnippet: urlSnippetValue, dataSource };
        if (tournamentName && eventName) {
            submitHandler({ ...base, eventDirectly: { tournamentName, eventName } });
        } else if (dataSource === 'fencingTime') {
            submitHandler({ ...base, sessionID });
        } else {
            submitHandler(base);
        }

        setRainbowValue('');
        setUrlSnippetValue('');
        setDataSource('');
        setTournamentName('');
        setEventName('');
        setSessionID('');
    }

    const changeRainbowValueHandler = event => {
        setRainbowValue(event.target.value);
    };

    const changeUrlSnippetValueHandler = event => {
        setUrlSnippetValue(event.target.value);
    };

    const changeDataSourceHandler = event => {
        const value = event.target.value;
        setDataSource(value);
        setTournamentName('');
        setEventName('');
        if (value === 'fencingTime') {
            callBackend('ftlSession', null, result => {
                if (result.isOk && result.data?.sessionID != null && result.data.sessionID !== '') {
                    setSessionID(String(result.data.sessionID));
                } else {
                    setSessionID('');
                }
            });
        }
    }

    const changeTournamentNameValueHandler = event => {
        setTournamentName(event.target.value);
    }

    const changeEventNameValueHandler = event => {
        setEventName(event.target.value);
    }

    const changeSessionIDValueHandler = event => {
        setSessionID(event.target.value);
    }

    const fetchHandler = () => {
        updateTourneamentHandler({returning: 'last'});
    }

    if( tournamentCreated ) return (
        <div className='TournamentMgmt'>
            Fetch Events of the new tournament (allow time to download the content):
            <Direction clickHandler={fetchHandler} name='Fetch Events' />
        </div>
    );

    return (
        <div className='TournamentMgmt'>
            <div>
                Source: <select value={dataSource} onChange={changeDataSourceHandler} className='TournamentMgmt'>
                    <option value="">Select</option>
                    <option value="fencingTime">Fencing Time</option>
                    <option value="enGarde">En Garde</option>
                    <option value="fencingWW">Fencing World Wide</option>
                </select>
            </div>

            { dataSource ?
                <>
                    <div className='TournamentMgmt-additional'>
                        Access key: <input className='TournamentMgmt TournamentMgmt-short'
                            type='text'
                            onChange={changeRainbowValueHandler}
                            value={rainbowValue} />
                    </div>
                    <div className='TournamentMgmt-additional'>
                        URL snippet: <input className='TournamentMgmt TournamentMgmt-long'
                            type='text'
                            onChange={changeUrlSnippetValueHandler}
                            value={urlSnippetValue} />
                    </div>
                </> : '' }

            { dataSource === 'fencingWW' ?
                <>
                    <div className='TournamentMgmt-additional'>
                        Tournament name: <input className='TournamentMgmt TournamentMgmt-long'
                            type='text'
                            onChange={changeTournamentNameValueHandler}
                            value={tournamentName} />
                    </div>
                    <div className='TournamentMgmt-additional'>
                        Event name: <input className='TournamentMgmt TournamentMgmt-long'
                            type='text'
                            onChange={changeEventNameValueHandler}
                            value={eventName} />
                    </div>
                </> : '' }

            { dataSource === 'fencingTime' ?
                <div className='TournamentMgmt-additional'>
                    Session ID: <input className='TournamentMgmt TournamentMgmt-long'
                        type='text'
                        onChange={changeSessionIDValueHandler}
                        value={sessionID} />
                </div> : '' }

            { tournamentName && eventName ? <div className='TournamentMgmt-strong'>CREATING ONE EVENT ONLY!</div> : '' }
            { dataSource && rainbowValue && urlSnippetValue
                && (dataSource !== 'fencingTime' || sessionID) ? <Ok clickHandler={clickHandler} /> : '' }
        </div>
    );
}

export default TournamentMgmt;